var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#038AB7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.403 19.443-4.056-4.053s-.042-.042-.084-.042c-.38.549-.803 1.098-1.31 1.604a9.464 9.464 0 0 1-1.605 1.309s.042.042.042.084l4.056 4.053a2.066 2.066 0 0 0 2.915 0c.845-.844.845-2.153.042-2.955zM16.508 3.666a9.068 9.068 0 0 0-12.842 0 9.068 9.068 0 0 0 0 12.842 9.068 9.068 0 0 0 12.842 0c3.554-3.554 3.554-9.329 0-12.842zM5.321 14.812a6.703 6.703 0 0 1 0-9.49 6.703 6.703 0 0 1 9.491 0 6.703 6.703 0 0 1 0 9.49c-2.585 2.625-6.866 2.625-9.49 0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-search.19f7dcb2bad42015adc969ed71235c0a.svg";